module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0118.jpg?v=01dc8dc2";